var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReplaceIcon32X32 = function SvgReplaceIcon32X32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#069BAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ReplaceIcon32x32_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M8 8h16v16H8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ReplaceIcon32x32_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.034 21.333c-1.49 0-2.756-.516-3.8-1.55-1.045-1.033-1.567-2.294-1.567-3.783v-.117l-.6.6a.632.632 0 0 1-.467.184.632.632 0 0 1-.466-.184.632.632 0 0 1-.184-.466c0-.19.061-.345.184-.467l1.733-1.733a.64.64 0 0 1 .466-.2.64.64 0 0 1 .467.2l1.733 1.733a.632.632 0 0 1 .184.467.632.632 0 0 1-.184.466.632.632 0 0 1-.466.184.632.632 0 0 1-.467-.184l-.6-.6V16c0 1.111.392 2.055 1.175 2.833.784.778 1.736 1.167 2.858 1.167.178 0 .353-.011.525-.033.173-.023.342-.061.509-.117a.795.795 0 0 1 .533.017.735.735 0 0 1 .383.35.603.603 0 0 1-.366.866 4.244 4.244 0 0 1-.784.192 5.548 5.548 0 0 1-.8.058ZM15.966 12c-.178 0-.353.011-.525.033a2.69 2.69 0 0 0-.508.117.82.82 0 0 1-.542-.017.731.731 0 0 1-.392-.35.566.566 0 0 1-.025-.508.574.574 0 0 1 .375-.342 4.954 4.954 0 0 1 1.617-.267c1.489 0 2.755.517 3.8 1.55 1.044 1.034 1.567 2.295 1.567 3.784v.117l.6-.6a.632.632 0 0 1 .466-.184c.19 0 .345.061.467.184a.632.632 0 0 1 .183.466.632.632 0 0 1-.183.467l-1.733 1.733a.64.64 0 0 1-.467.2.64.64 0 0 1-.467-.2l-1.733-1.733a.632.632 0 0 1-.183-.467c0-.189.06-.344.183-.466a.632.632 0 0 1 .466-.184c.19 0 .345.061.467.184l.6.6V16c0-1.111-.392-2.056-1.175-2.833C18.042 12.389 17.09 12 15.967 12Z",
    fill: "#fff"
  }))));
};
export default SvgReplaceIcon32X32;